import { render, staticRenderFns } from "./teacherReport.vue?vue&type=template&id=80ab0d88&scoped=true"
import script from "./teacherReport.vue?vue&type=script&lang=js"
export * from "./teacherReport.vue?vue&type=script&lang=js"
import style0 from "./teacherReport.vue?vue&type=style&index=0&id=80ab0d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ab0d88",
  null
  
)

export default component.exports